import pageInit from '@/router/page-init'
import store from '@/store/index'
import NProgress from 'nprogress'
import { checkMiniEnv } from '@/views/live-slice/utils'
import { saveChannelId } from '@/utils/channel'
import { resolveChannelAttribution } from '@/utils/channel-attribution.mjs'

function resolveH5ChannelBindRoute(to) {
  if (!/^\/h5\/video-clip(?:\/|$)/.test(to.path) || to.name === 'h5-video-clip-bind') return null

  const attribution = resolveChannelAttribution(to.query)
  if (!attribution) return null

  const query = { ...to.query }
  delete query.promote_code
  delete query.sub_channel_id
  if (attribution.subChannelId) query.sub_channel_id = attribution.subChannelId

  return {
    name: 'h5-video-clip-bind',
    params: { promoteCode: attribution.promoteCode },
    query,
    replace: true
  }
}

export default async function beforeEach(to, from, next) {
  NProgress.start()
  store.dispatch('route/before', { to, from })
  store.dispatch('route/loadingBefore', true)
  const channelBindRoute = resolveH5ChannelBindRoute(to)
  if (channelBindRoute) {
    next(channelBindRoute)
    return
  }
  await pageInit(to, next)
  saveChannelId(to.query)
  checkMiniEnv(to)
}
